export default __webpack_public_path__ + "static/media/tablet.7699c856.png";